export const READY = 0;
export const IN_PROGRESS = 1;
export const EXPIRED = 2;
